const FilterCheck = ({ ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.38727 13.2737C7.23352 13.2737 7.08352 13.21 6.97852 13.0975L3.90352 9.83499C3.68977 9.60999 3.70102 9.25374 3.92602 9.03999C4.15102 8.82624 4.50727 8.83749 4.72102 9.06249L7.37602 11.8787L13.0798 5.43999C13.286 5.20749 13.6423 5.18499 13.8748 5.39124C14.1073 5.59749 14.1298 5.95374 13.9235 6.18624L7.81477 13.0862C7.70977 13.2062 7.55977 13.2737 7.40227 13.2775H7.39477L7.38727 13.2737Z"
      fill="#646464"
    />
  </svg>
)

export default FilterCheck
